export default {
  header: 'Nous devons vérifier votre numéro de téléphone',
  remember_device: {
    label: 'Se souvenir de cet appareil pendant {{days}} jours',
  },
  buttons: {
    confirm: 'Confirmer',
  },
  toasts: {
    invalid_code: 'Code invalide. Veuillez réessayer.',
  },
};
